// frontend/src/features/viewer/McBimItemDetails.tsx
import React from "react";
import { Alert, Loader, Stack } from "@mantine/core";
import { FaInfoCircle } from "react-icons/fa";
import { useGetMcbimItemQuery } from "../../../openapi";
import { useAppSelector } from "../../app/hooks";
import { selectProjectNo } from "../../globalSelectors";
import { selectClickedMcBimItemId } from "../../ViewerRedux/viewerSlice";
import { McBimItemDetailsTable } from "./McBimItemDetailsTable";
import { FailedAlert } from "../FailedAlert";
import { MmiSingleItem } from "./MMISingleItem";

export const McBimItemDetails: React.FC = () => {
  const projectNo = useAppSelector(selectProjectNo);
  const itemId = useAppSelector(selectClickedMcBimItemId);

  const { data, isLoading, isFetching, isError } = useGetMcbimItemQuery(
    { projectNo, itemId: itemId?.trim() ?? "" },
    { skip: !projectNo || !itemId }
  );

  if (!itemId) {
    return (
      <Alert icon={<FaInfoCircle />} title="Detaljer" variant="light" style={{ maxWidth: "500px" }}>
        Klikk på en komponent i modellen for å se detaljer.
      </Alert>
    );
  }

  if (isLoading || isFetching) {
    return <Loader />;
  }

  if (isError || !data) {
    return <FailedAlert />;
  }

  return (
    <Stack p="md" w="100%" h="100%">
      <MmiSingleItem />
      <McBimItemDetailsTable />
    </Stack>
  );
};
